import { useCallback, useEffect, useState } from "react";
import { CardContentHeaderActionsProps } from "../../props/CardContentHeaderActionsProps";
import { Button, DropDownButton } from "@progress/kendo-react-buttons";
import { DotsThreeOutlineVertical, Trash } from "phosphor-react-sc";
import { IconPicker } from "../../../icons/IconPicker";
import parse from 'html-react-parser';

export const CardContentHeaderActions = ({
    cardService,
    actions = [],
    actionsDisplay = "dropdown",
    borderColor = "var(--card-border)",
    backgroundColor = "var(--card-body-bg)",
    adjustedIconColor,
    dispatcherService,
    showDeleteButtonOnMobile,
    onItemClick

}: CardContentHeaderActionsProps) => {

    const [localActions, setLocalActions] = useState<any[]>([]);
    const [opacity, setOpacity] = useState<number>(1);
    const [display, setDisplay] = useState<string>("flex");

    const onDelete = useCallback((e: unknown | null) => {
        dispatcherService.onDelete(e);
    }, [dispatcherService]);

    useEffect(() => {
        const localActions = Object.assign([], actions);
        if (cardService.canSelect && cardService.hasActions) {
            localActions.push({
                title: "Slett",
                onClick: onDelete
            })
        }
        setLocalActions(localActions);

        cardService.onDeleteOpacityChange = setOpacity;
        cardService.onDeleteDisplayChange = setDisplay;

        return (() => {
            cardService.onDeleteOpacityChange = () => { };
            cardService.onDeleteDisplayChange = () => { };
        })
    }, [actions, cardService, onDelete]);

    return (
        <div className="crd-content-header-actions" style={{ display: display, opacity: opacity, backgroundColor: backgroundColor } } >
            {
                (cardService.canDelete && !cardService.hasActions) &&
                <Button
                    className={!showDeleteButtonOnMobile ? "crd-content-header-action-delete" : ""}
                    style={{ backgroundColor: borderColor }}
                        onClick={onDelete}>
                    <Trash weight="duotone" size={32} color={adjustedIconColor} />
                </Button>
            }
            {
                (cardService.hasActions) &&
                    (actionsDisplay) === "dropdown" ?
                        <DropDownButton
                            style={{ backgroundColor: borderColor }}
                            items={localActions}
                            onItemClick={onItemClick}
                            itemRender={DropDownButtonActionRender}
                            text={<DotsThreeOutlineVertical weight="duotone" size={32} color={adjustedIconColor} />} />
                    :
                    actions.map((action, index) =>
                        <div key={index}>
                            <Button onClick={action.onClick}
                                style={{ backgroundColor: borderColor }}>
                                <IconPicker icon={action.icon} size={32} color={adjustedIconColor} />
                            </Button>
                        </div>
                    )
            }
        </div>
    )
}

const DropDownButtonActionRender = (props: any) => {
    return (
        <div className="drop-down-button-item">
            {parse(props.item.title)}
        </div>
    );
}
